import { render, staticRenderFns } from "./MobileResume.vue?vue&type=template&id=4a8bf306&scoped=true&"
import script from "./MobileResume.vue?vue&type=script&lang=ts&"
export * from "./MobileResume.vue?vue&type=script&lang=ts&"
import style0 from "./MobileResume.vue?vue&type=style&index=0&id=4a8bf306&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8bf306",
  null
  
)

export default component.exports